import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography, Box } from "@material-ui/core";

import { BY_MY } from "../../../../constants";
import { UNREALIZED_COLORS } from "../../constants";
import { Toggle } from "../../../../components/toggle";
import { ShaDowBox } from "../../../../components/boxes";
import { NoDataCard } from "../../../../components/parts";
import { UnrealizedBarChart } from "../../../../components/charts";
import { api, requestDateFormat, isResponseDataPerMonth } from "../../../../services";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  span: {
    fontSize: 14,
    fontWeight: 300,
  },
}));

export const UnrealizedRevenuesBarChart = ({ period, startDate, endDate }) => {
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [byFilter, setByFilter] = useState();
  const [defaultFilter, setDefaultFilter] = useState();
  const [currentUrl, setCurrentUrl] = useState();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => {
        const isDataPerMonth = isResponseDataPerMonth(resp.data.results);
        const data = resp.data.results.map((item) => {
          const date = new Date(item.date);
          const d = `${date.getUTCFullYear()}${isDataPerMonth ? `-${date.getUTCMonth() + 1}` : ""}`;
          return {
            ...item,
            name: `${d}${"estimated" in item ? "E" : ""}`,
          };
        });
        setData(data);
        setDefaultFilter(resp.data.date_format === "year" ? BY_MY[1] : BY_MY[0]);
      });
    };

    setByFilter(null);
    let url = "/praas/v1/unrealized/trading-assets-graph/";
    if (period.name === "RANGE" && endDate) {
      url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
      getData(url);
      setCurrentUrl(url);
    } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
      url += `?date_filter=${period.filter}`;
      getData(url);
      setCurrentUrl(url);
    }
  }, [period, startDate, endDate]);

  useEffect(() => {
    if (byFilter) {
      let dateFormat = `date_format=${byFilter === BY_MY[0] ? "month" : "year"}`;

      api.get(`${currentUrl}&${dateFormat}`).then((resp) => {
        const isDataPerMonth = isResponseDataPerMonth(resp.data.results);
        const data = resp.data.results.map((item) => {
          const date = new Date(item.date);
          const d = `${date.getUTCFullYear()}${isDataPerMonth ? `-${date.getUTCMonth() + 1}` : ""}`;

          return {
            ...item,
            name: `${d}${"estimated" in item ? "E" : ""}`,
          };
        });
        setData(data);
      });
    }
  }, [currentUrl, byFilter]);

  return (
    <Grid item xs={12} sm={8} id="unrealized-revenues-over-time">
      <ShaDowBox style={{ height: "100%" }}>
        {data.length ? (
          <Box className={classes.box}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h4">
                Unrealized Revenues Over Time{" "}
                <span className={classes.span}>({currencySymbol})</span>
              </Typography>
              <Grid container style={{ width: "fit-content" }}>
                <Typography style={{ marginRight: 4 }}>By:</Typography>
                <Toggle value={byFilter || defaultFilter} options={BY_MY} onChanged={setByFilter} />
              </Grid>
            </Grid>

            <UnrealizedBarChart chartData={data} colors={UNREALIZED_COLORS} height={360} top={50} />
          </Box>
        ) : (
          <NoDataCard title={`Unrealized Revenues Over Time (${currencySymbol})`} />
        )}
      </ShaDowBox>
    </Grid>
  );
};
